module.exports = __webpack_public_path__ + "static/no-visible-bruises-3532ee69ffc0e8ff39b39ee13d8a45a1.jpg";